module.exports = __webpack_public_path__ + "static/media/2.21e7351b.jpg";